var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-layout"}},[_c('navbar'),_c('disclaimer'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }